module.exports = __webpack_public_path__ + "static/Q5Answer6_Red_JasonDent-7eebfe6b7e7de3d1b74ccfc7aeb3e177.jpg";